import { render, staticRenderFns } from "./HubCategory.vue?vue&type=template&id=3996446a&"
import script from "./HubCategory.vue?vue&type=script&lang=js&"
export * from "./HubCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports